<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
  mounted () {
    let loading = document.querySelector('#loading')
    loading.style.opacity = 0
    loading.style.transform = 'scale(5)'

    let app = document.querySelector('#app')
    app.style.opacity = 1
    setTimeout(() => loading.remove(), 500)
  }
}
</script>
<style lang="scss">
    @import "./assets/main.css";
    @import "./assets/font-awesome/css/font-awesome.min.css";

    #app{
        opacity: 0;
        transition: all 1s;
    }

    .el-row {
        margin-bottom: 20px;
    }

    .el-menu-item-group__title{
        padding-left: 10px!important;
    }

    .page-title{
        margin-bottom:10px;
        border-bottom:1px solid #efefef;
        padding-bottom:10px;
    }

    .el-breadcrumb{
        margin: 20px 0;
    }

    .toolbar{
        margin: 10px 0;
        padding-bottom: 10px;
        border-bottom: 1px solid #efefef;
    }

    .el-form .el-select{
        width: 100%;
    }

    .el-table{
        a {
            text-decoration: underline;
            color: #409eff;
        }
        .thumb{
            width:120px; height: 80px;
            img{
                width:100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .el-table{
        font-size: 12px;
    }
    .el-table td, .el-table th{
        padding: 5px 0;
        .cell{
            padding-left:5px;
            padding-right:5px;
            .el-button--mini, .el-button--mini.is-round{
                padding: 5px 8px;
            }
            .el-button+.el-button{
                margin-left: 4px;
            }
        }
    }

    .filters {
        .el-form{
            display: flex;
            align-items: flex-end;
            .el-form-item__label{
                line-height: 1.5
            }
            .el-form-item__content{
                line-height: 32px;
                width:100%;
            }
        }
        font-size: 12px;
        .label {
            line-height: 32px;
            text-align: center;
        }
        .el-button {
            width: 100%;
        }
    }
</style>
